"use client";
import { Header } from "@/components";
import Footer from "@/components/officer-dashboard/officer-reset-password/Footer";
import { ForgotPasswordContext } from "@/context";
import { useState } from "react";
import RenderForgotPasswordForm from "./render-forgot-password-form";

const ForgotPassword = () => {
  const [step, setStep] = useState(0);
  return (
    <ForgotPasswordContext.Provider value={{ step, setStep }}>
      <div className="bg-gray-100 flex flex-col gap-6">
        <Header />
        <div className="w-full mt-[112px]">
          <RenderForgotPasswordForm />
          <Footer />
          <img
            src="/officer-login.png"
            className="w-full h-32 object-cover mt-24 opacity-10"
          />
      </div>
    </div>
        
    </ForgotPasswordContext.Provider>
  );
};

export default ForgotPassword;
